export default "__VITE_PUBLIC_ASSET__7f1f41b6__"